<script setup lang="ts">
const userStore = useUserStore();
</script>

<template>
  <HeadlessPopover
    v-slot="{ close }"
    class="hidden md:block relative text-neutral-200 mt-1">
    <HeadlessPopoverButton
      class="focus:outline-hidden"
      data-test="notification-header-button">
      <div v-if="userStore.isLoggedIn" class="relative">
        <NuxtIcon name="mdi:bell" class="w-8 h-8 text-neutral-300" />
        <HeaderAccountNotificationsCounter />
      </div>
    </HeadlessPopoverButton>
    <transition
      enter-active-class="transition ease-out duration-200"
      enter-from-class="transform opacity-0 translate-x-full md:translate-x-0 md:scale-95"
      enter-to-class="transform opacity-100 translate-x-0 md:scale-100"
      leave-active-class="transition ease-in duration-200"
      leave-from-class="transform opacity-100 translate-x-0 md:scale-100"
      leave-to-class="transform opacity-0 translate-x-full md:translate-x-0 md:scale-95">
      <HeadlessPopoverPanel
        class="md:absolute top-11 -right-0 md:-right-2 md:h-auto md:w-[479px] bg-neutral-800 flex-col shadow-sm shadow-black md:border border-secondary-500 md:rounded-lg z-10">
        <HeaderAccountNotificationsDropdown
          mode="desktop"
          @close="close()" /> </HeadlessPopoverPanel
    ></transition>
  </HeadlessPopover>
</template>
